export default () => {
    const groupDeleteModal = document.getElementById('groupDeleteModal');
    if (!groupDeleteModal) {
        return;
    }
    // todo finish delete modal
    // todo open redirect
    groupDeleteModal.addEventListener('show.bs.modal', (event) => {
        const {
            email,
            name,
            action,
            redirect
        } = event.relatedTarget.dataset;

        groupDeleteModal.querySelector('#groupDelete').setAttribute('action', action);
        groupDeleteModal.querySelector('#email').value = email;
        groupDeleteModal.querySelector('#name').value = name;
        groupDeleteModal.querySelector('#redirect').value = redirect;
    });
};
